import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class UTCDateAdapter extends NativeDateAdapter {
  override parse(value: any): Date | null {
    if (typeof value === 'string' && value.includes('/')) {
      const [day, month, year] = value.split('/').map(Number);
      return new Date(Date.UTC(year, month - 1, day));
    }
    const timestamp = Date.parse(value);
    return isNaN(timestamp) ? null : new Date(Date.UTC(new Date(timestamp).getUTCFullYear(), new Date(timestamp).getUTCMonth(), new Date(timestamp).getUTCDate()));
  }

  override format(date: Date): string {
    const day = this._to2digit(date.getUTCDate());
    const month = this._to2digit(date.getUTCMonth() + 1);
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  }

  override toIso8601(date: Date): string {
    return date.toISOString().substring(0, 10);
  }

  private _to2digit(n: number): string {
    return ('00' + n).slice(-2);
  }

  override createDate(year: number, month: number, date: number): Date {
    return new Date(Date.UTC(year, month, date));
  }
}
